import React from 'react'
// import { setConfig } from 'react-hot-loader'
// setConfig({ logLevel: 'no-errors-please' })
import classnames from 'classnames'
import Helmet from 'react-helmet'
import Header from './Header'
import Home from './Home'
import Lodge from './Lodge'
import Bistro from './Bistro'
import Yoho from './Yoho'
import Groups from './Groups'
import FAQ from './FAQ'
import Footer from './Footer'
// import { Link } from 'gatsby';
// import PropTypes from 'prop-types';

import largeFavicon from '../img/favicon-32x32.png'
import smallFavicon from '../img/favicon-16x16.png'
import appleTouchIcon from '../img/apple-touch-icon.png'
import safariPinnedTab from '../img/safari-pinned-tab.svg'

import './all.sass'
import layoutStyles from './layout.module.sass'
import FullWidthSection from './FullWidthSection'

require('typeface-lato')

export default class TemplateWrapper extends React.Component {
  constructor(props) {
    super(props) // not needed unless we need to access props directly within constructor
    // this.render = this.render.bind(this);
    this.state = {
      burgerColor: 'white',
      logoLoaded: false,
    }
    this.changeBurgerColor = this.changeBurgerColor.bind(this)
    //this.setLogoLoaded = this.setLogoLoaded.bind(this);
    //this.readyToCalcHeight = false;
  }

  // setLogoLoaded() {
  //   this.setState({ 'logoLoaded': true });
  //   console.log('logo LOADED!');
  // }

  changeBurgerColor(color) {
    this.setState({ burgerColor: color })
  }

  render() {
    const { children, allPages, slug, acfOptions, acf } = this.props
    const { burgerColor } = this.state

    // console.log('allPages')
    // console.log(allPages)

    return (
      <div
        id="outer-container"
        className={classnames(layoutStyles.layout, slug)}
      >
        <Helmet
          title="Truffle Pigs Bistro + Lodge 🐷 Field, British Columbia ⛰ Yoho National Park"
          link={[
            { rel: 'icon', type: 'image/png', href: `${largeFavicon}` },
            { rel: 'icon', type: 'image/png', href: `${smallFavicon}` },
            {
              rel: 'apple-touch-icon',
              type: 'image/png',
              sizes: '180x180',
              href: `${appleTouchIcon}`,
            },
            { rel: 'mask-icon', href: `${safariPinnedTab}` },
          ]}
          meta={[
            {
              name: 'description',
              content:
                "Award winning restaurant and hotel in Canada's Rocky Mountains",
            },
          ]}
        >
          <body className={classnames(layoutStyles.body, slug)} />
        </Helmet>

        <Header allPages={allPages} slug={slug} burgerColor={burgerColor} />

        {children}
        {slug === 'home' && (
          <Home
            acf={acf}
            onScrolledOverDifferentColor={this.changeBurgerColor}
          />
        )}
        {slug === 'lodge' && (
          <FullWidthSection
            onScrolledOverDifferentColor={this.changeBurgerColor}
          >
            <Lodge acf={acf} acfOptions={acfOptions} />
          </FullWidthSection>
        )}
        {slug === 'bistro' && (
          <FullWidthSection
            onScrolledOverDifferentColor={this.changeBurgerColor}
          >
            <Bistro acf={acf} />
          </FullWidthSection>
        )}
        {slug === 'yoho-national-park' && (
          <FullWidthSection
            onScrolledOverDifferentColor={this.changeBurgerColor}
          >
            <Yoho acf={acf} acfOptions={acfOptions} />
          </FullWidthSection>
        )}
        {slug === 'groups-and-packages' && (
          <Groups
            acf={acf}
            onScrolledOverDifferentColor={this.changeBurgerColor}
          />
        )}
        {slug === 'frequently-asked-questions' && (
          <FullWidthSection
            onScrolledOverDifferentColor={this.changeBurgerColor}
          >
            <FAQ acf={acf} acfOptions={acfOptions} />
          </FullWidthSection>
        )}
        {acfOptions && <Footer footerProps={acfOptions.site_footer} />}
      </div>
    )
  }
}
